import { FC } from "react";
import { useAppStore } from "store/store";
import Content from "content/content";
import LocalImages from "assets/images/local-images";
import SubmitButton from "features/shared/components/buttons/submit-button/SubmitButton";
import { BannerClientProps } from "./SuccessBannerClient";

import Body from "features/shared/styles/typography/Body.styled";
import { TertiaryHeader } from "features/shared/styles/typography/TertiaryHeader.styled";

import DefaultSuccessBanner from "./styles/SuccessBanner.styled";
import DefaultSuccessContent from "./styles/SuccessContent.styled";

const SuccessBannerClient: FC<BannerClientProps> = ({
  title,
  description,
  buttonText,
  isButtonVisible,
  onClick,
}) => {
  useAppStore((state) => state.locale);
  const images = LocalImages.shared.images;
  const direction = Content.shared.instance.dir();

  return (
    <DefaultSuccessBanner direction={direction}>
      <img alt="success banner icon" src={images.icons.banner.success} />

      <DefaultSuccessContent>
        <TertiaryHeader>{title}</TertiaryHeader>
        <Body>{description}</Body>
        {isButtonVisible ? (
          <SubmitButton onClick={onClick}>{buttonText}</SubmitButton>
        ) : null}
      </DefaultSuccessContent>
    </DefaultSuccessBanner>
  );
};

export default SuccessBannerClient;
